/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Модель для товара
   */
  app.Item = app.Model.extend({
    urlRoot: app.entryScriptName + '/api/v3/item-search',
    getUrl: function () {
      return app.entryScriptName + '/' + this.get('sid') + '/' + this.get('slug') + '/';
    },
    /**
     * Получить url до фото с указанным номером и указанным размером
     * @param n
     * @param size
     * @returns {string}
     */
    getPhotoUrl: function (n, size) {
      if (n === undefined || n === null) {
        n = this.getFirstIndexPhoto();
      }
      size = size || 140;
      var productIdStr = '' + this.get('id'),
        photoIndexes = this.get('photoIndexes');
      if (_.isArray(photoIndexes) && photoIndexes.length && photoIndexes.indexOf(n.toString()) !== -1) {
        var photoPath = app.photoCDN + '/items/' + productIdStr + '/' + n + '/' + size + '.jpg';
        var photoVersion = this.getPhotoVersion(n);
        photoPath += '?v=' + photoVersion;
        return photoPath;
      }
      return app.photoCDN + '/items/default/' + size + '.jpg';
    },
    /**
     * Получить индекс первого фото
     * @returns {number}
     */
    getFirstIndexPhoto: function () {
      var indexes = this.get('photoIndexes');
      if (indexes) {
        return indexes[0];
      }
      return 0;
    },
    getFirstPhoto3d: function () {
      var photo3ds = this.get('itemPhoto3ds');
      if (photo3ds) {
        return _.head(photo3ds);
      }
      return '';
    },
    /**
     * Получить версию фото с указанным индексом
     * @param index
     * @returns {Number}
     */
    getPhotoVersion: function (index) {
      var photoVersions = this.get('photoVersions');
      var photo = _.find(photoVersions, ['number', index + '']);

      if (photo) {
        var version = parseInt(photo.version, 10);
        if (_.isNumber(version) && !_.isNaN(version)) {
          return version;
        }
      }
      return 0;
    },

    /**
     * Возвращает объект с шильдиками.
     * @static
     * @param {Object} badges Шильдики текущего товара.
     * @param {Object} badgesTemplates Шаблоны шильдиков, приходят вместе
     *                                 с товаром|коллекцией товаров в `_meta.badges`.
     * @returns {Array} Массив с шильдиками.
     */
    getBadges: function (badges, badgesTemplates) {
      return badges.map(function (badge) {
        var templates = _.cloneDeep(badgesTemplates[badge.type]);
        return _.assign(templates, badge);
      });
    }
  });
})(jQuery);

}.call(window));